import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faFolderOpen, faSearch } from '@fortawesome/free-solid-svg-icons';

class Icons {
  constructor() {
    import('@fortawesome/fontawesome-svg-core').then(({ library, dom }) => {
      // add the imported icons to the library
      library.add(faFacebook, faInstagram, faFolderOpen, faSearch);
      // Replace <i> by svg
      dom.i2svg();
    });
  }
}

new Icons();
